import { Injectable } from '@angular/core';
import { EstudoRenovacao } from './estudo-renovacao';
import { Observable } from 'rxjs';
import { ServiceUtil } from '../util/service.util';
import { PagerComponent } from '../paginator/pager.component';

import { HttpService } from 'ems-oauth2-client';
import { HttpHeaders } from '@angular/common/http';
import { map, catchError , publishReplay, refCount} from 'rxjs/operators';

@Injectable()
export class EstudoRenovacaoService extends ServiceUtil {

  private headers: HttpHeaders = new HttpHeaders({
    'Content-Type': 'application/json'
  });
  private url = '/sae/estudo/socioeconomico/renovacao';
  private filtro: EstudoRenovacao = new EstudoRenovacao();

  constructor(
    private http: HttpService,
    private pagerComponent: PagerComponent
  ) {
    super();
  }

  // altera ou inclui EstudoRenovacao
  public update(estudo: EstudoRenovacao): Observable<EstudoRenovacao> {
    const body = JSON.stringify(estudo);
    if (!estudo.id) {
      return this.http
        .post(this.url, body)
        .pipe(map(response => <EstudoRenovacao>response),
             catchError(this.handleError),
             publishReplay(1),
             refCount());
    } else {
      return this.http
        .put(this.url + '/' + estudo.id, body)
        .pipe(map(response => <EstudoRenovacao>response),
              catchError(this.handleError),
              publishReplay(1),
              refCount());
    }
  }

  // lista todos (sem filtro)
  public listar(): Observable<EstudoRenovacao[]> {
    return this.http
      .get(this.url)
      .pipe(map(this.extractListData),
            catchError(this.handleError),
            publishReplay(1),
            refCount());
  }

  public inicializa(matricula: string) {
    return this.http
      .get(this.url + '/inicializa/' + matricula)
      .pipe(map(this.extractObjectData),
            catchError(this.handleError),
            publishReplay(1),
            refCount());
  }

  public houveAlteracao(idEstudo: number) {
    return this.http
      .get(this.url + '/alteracao/' + idEstudo)
      .pipe(map(this.extractObjectData),
            catchError(this.handleError),
            publishReplay(1),
            refCount());
  }

  public controlaResposta(idResposta: number) {
    return this.http
      .get(this.url + '/controle/' + idResposta)
      .pipe(map(this.extractObjectData),
            catchError(this.handleError),
            publishReplay(1),
            refCount());
  }

  // filtra
  public filtrar(filtro:EstudoRenovacao, ordenar: string): Observable<EstudoRenovacao[]> {
    let colocaVirgula = false;
    let novaUrl = '{';
    if (filtro.alunoRa) {
      novaUrl += 'alunoRa:"' + filtro.alunoRa + '"';
      colocaVirgula = true;
    }
    if (filtro.id) {
      if (colocaVirgula) {
        novaUrl += ', ';
      }
      novaUrl += 'id:"' + filtro.id + '"';
      colocaVirgula = true;
    }
    if (filtro.alunoNome) {
      if (colocaVirgula) {
        novaUrl += ', ';
      }
      novaUrl += 'alunoNome__contains:"' + filtro.alunoNome + '"';
      colocaVirgula = true;
    }
    if (filtro.periodo) {
      if (colocaVirgula) {
        novaUrl += ', ';
      }
      novaUrl += 'periodo:"' + filtro.periodo + '"';
      colocaVirgula = true;
    }

    if (filtro.renovado) {
      if (colocaVirgula) {
        novaUrl += ', ';
      }
      novaUrl += 'renovado:"' + filtro.renovado + '"';
      colocaVirgula = true;
    }

    novaUrl += '}';
    let urlModify = this.pagerComponent.formatarUrl(this.url, novaUrl, 100, 0);

    if (ordenar) {
      urlModify += '&sort= ' + ordenar;
    } else {
      urlModify += '&sort= renovado asc';
    }

    return this.http
      .get(urlModify)
      .pipe(map(response => {
        return <EstudoRenovacao[]>response;
      }),
          catchError(this.handleError),
          publishReplay(1),
          refCount());
  }

  // recupera por id
  public getId(id: number): Observable<EstudoRenovacao> {
    return this.http
      .get(this.url + '/' + id)
      .pipe(map(this.extractObjectData),
            catchError(this.handleError),
            publishReplay(1),
            refCount());
  }
  
  deletar(estudoRenovacao: EstudoRenovacao): Observable<EstudoRenovacao> {
    return this.http.delete(this.url + "/" + estudoRenovacao.id)
      .pipe(map(response => response),catchError(this.handleError));
  }

  pontuaAutomatico(estudoRenovacao: EstudoRenovacao) {
    const body = JSON.stringify(estudoRenovacao);
    return this.http
        .post(this.url + "/pontuaAutomatico", body)
        .pipe(map(response => <EstudoRenovacao>response),
              catchError(this.handleError),
              publishReplay(1),
              refCount());
  }

  pontuaManual(estudoRenovacao: EstudoRenovacao) {
    const body = JSON.stringify(estudoRenovacao);
    return this.http
        .post(this.url + "/pontuaManual", body)
        .pipe(map(response => <EstudoRenovacao>response),
              catchError(this.handleError),
              publishReplay(1),
              refCount());
  }

  // extrai lista da resposta http
  private extractListData(res: any) {
    return res as EstudoRenovacao[];
  }

  // extrai objeto da resposta http
  private extractObjectData(res: any) {
    return res as EstudoRenovacao;
  }


  removeNull(key, value) {
    // Filtering out properties
    if (value === null) {
      return undefined;
    }
    return value;
  }
 
}
